import { useStaticQuery, graphql } from 'gatsby'
export default function useGetPost(slug) {
    const data = useStaticQuery(graphql`
        {
            allWpService {
                nodes {
                  slug
                  uri
                  sectors {
                    nodes {
                      slug
                    }
                  }
                }
              }
        }
    `)
    const servicePath = data.allWpService.nodes.filter((node)=>{
        return node.uri === slug
    })[0]
    return servicePath ? `/${servicePath?.sectors?.nodes[0]?.slug}/${servicePath?.slug}` : null
}